<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="AddAttnGroup" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="名称" prop="PaAttnGroup.name">
            <el-input class="input-item" v-model="formData.PaAttnGroup.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="允许外勤" prop="PaAttnGroup.anywhereFlag">
            <el-select class="input-item" v-model="formData.PaAttnGroup.anywhereFlag" :clearable="true" filterable
              placeholder="允许外勤" :loading="AddAttnGroup.anywhereFlag.impl.loading"
              @visible-change="AddAttnGroup.anywhereFlag.impl.onVisibleChange"
              @change="onAnywhereFlagValueChange">
              <el-option v-for="item in AddAttnGroup.anywhereFlag.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaAttnGroup.detail">
            <el-input class="input-item" v-model="formData.PaAttnGroup.detail"
              :clearable="true" placeholder="描述"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaAttnGroup.remark">
            <el-input class="input-item" v-model="formData.PaAttnGroup.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              取消
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('AddAttnGroup:AddAttnGroup:add')"
              @click="onAddClick()">
              新增
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaAttnGroupController, DictionaryController } from '@/api';

export default {
  name: 'AddAttnGroup',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        PaAttnGroup: {
          id: undefined,
          name: undefined,
          anywhereFlag: undefined,
          detail: undefined,
          remark: undefined,
          deletedFlag: undefined,
          paAttnGroupLine: {
          },
          sysUser: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'PaAttnGroup.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ]
      },
      AddAttnGroup: {
        formFilter: {
        },
        formFilterCopy: {
        },
        anywhereFlag: {
          impl: new DropdownWidget(this.loadAnywhereFlagDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 允许外勤下拉数据获取函数
     */
    loadAnywhereFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 允许外勤选中值改变
     */
    onAnywhereFlagValueChange (value) {
    },
    /**
     * 更新添加考勤组
     */
    refreshAddAttnGroup (reloadData = false) {
      if (!this.AddAttnGroup.isInit) {
        // 初始化下拉数据
      }
      this.AddAttnGroup.isInit = true;
    },
    /**
     * 新增
     */
    onAddClick () {
      this.$refs.AddAttnGroup.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            anywhereFlagDictMap: findItemFromList(this.AddAttnGroup.anywhereFlag.impl.dropdownList, this.formData.PaAttnGroup.anywhereFlag, 'id'),
            ...this.formData.PaAttnGroup
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          paAttnGroupDto: {
            name: this.formData.PaAttnGroup.name,
            anywhereFlag: this.formData.PaAttnGroup.anywhereFlag,
            detail: this.formData.PaAttnGroup.detail,
            remark: this.formData.PaAttnGroup.remark
          }
        };

        PaAttnGroupController.add(this, params).then(res => {
          this.$message.success('新增成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaAttnGroup: {
          id: undefined,
          name: undefined,
          anywhereFlag: undefined,
          detail: undefined,
          remark: undefined,
          deletedFlag: undefined,
          paAttnGroupLine: {
          },
          sysUser: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshAddAttnGroup();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.PaAttnGroup = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
